var BlockStd = Object.getPrototypeOf(app).BlockStd = new Component("block-std");
BlockStd.debug = false;
BlockStd.createdAt      = "1.0.0";
BlockStd.lastUpdate     = "1.4.8";
BlockStd.version        = "1.0.2";



// WEBPACK FOOTER //
// ./src/components/block-std/block-std.js